//样式表
import './style.css'

//Gui调试库
import * as dat from 'lil-gui'

//Three.js库
import * as THREE from 'three'

//3D文件引入库
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'

//
import gsap from 'gsap'


const SimplexNoise = require('simplex-noise'),
    simplex = new SimplexNoise(Math.random)

function computeCurl(x, y, z) {
    var eps = 0.0001;

    var curl = new THREE.Vector3();

    //Find rate of change in YZ plane
    var n1 = simplex.noise3D(x, y + eps, z);
    var n2 = simplex.noise3D(x, y - eps, z);
    //Average to find approximate derivative
    var a = (n1 - n2) / (2 * eps);
    var n1 = simplex.noise3D(x, y, z + eps);
    var n2 = simplex.noise3D(x, y, z - eps);
    //Average to find approximate derivative
    var b = (n1 - n2) / (2 * eps);
    curl.x = a - b;

    //Find rate of change in XZ plane
    n1 = simplex.noise3D(x, y, z + eps);
    n2 = simplex.noise3D(x, y, z - eps);
    a = (n1 - n2) / (2 * eps);
    n1 = simplex.noise3D(x + eps, y, z);
    n2 = simplex.noise3D(x - eps, y, z);
    b = (n1 - n2) / (2 * eps);
    curl.y = a - b;

    //Find rate of change in XY plane
    n1 = simplex.noise3D(x + eps, y, z);
    n2 = simplex.noise3D(x - eps, y, z);
    a = (n1 - n2) / (2 * eps);
    n1 = simplex.noise3D(x, y + eps, z);
    n2 = simplex.noise3D(x, y - eps, z);
    b = (n1 - n2) / (2 * eps);
    curl.z = a - b;

    return curl;
}



/**
 * Base基础设置
 */

// Debug
const debugObject = {}
const gui = new dat.GUI({
    width: 400
})
const folder1 = gui.addFolder('mainScence')
const folder2 = gui.addFolder('waterSurface')
const folder3 = gui.addFolder('hollowLight')
const folder4 = gui.addFolder('fireflies')
gui.close()
folder1.close()
folder2.close()
folder3.close()
folder4.close()



// Canvas画布
const canvas = document.querySelector('canvas.webgl')

// Scene场景
const scene = new THREE.Scene()

/**
 * Sizes 画面尺寸
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    // Update fireflies
    firefliesMaterial.uniforms.uPixelRatio.value = Math.min(window.devicePixelRatio, 2)
})


/**
 * Camera相机
 */

// Group
const cameraGroup = new THREE.Group()
scene.add(cameraGroup)

// Base camera基础相机
const camera = new THREE.PerspectiveCamera(55, sizes.width / sizes.height, 0.01, 100)

const xStart = 3
const xEnd = -1
const yStart = 20
const yEnd = 0.5

camera.position.x = xStart
camera.position.y = yStart
camera.position.z = 0.35

camera.lookAt(-2, 0.33, 0.35)
cameraGroup.add(camera)


// gui.add(camera.position, 'x').min(-10).max(10).step(0.01).name('cameraX')
// gui.add(camera.position, 'y').min(0).max(10).step(0.01).name('cameraY')
// gui.add(camera.position, 'z').min(-10).max(10).step(0.01).name('cameraZ')

/**
 * Fog
 */
const fog = new THREE.Fog('#82939b', 4, 25)
scene.fog = fog

/**
 * Renderer渲染
 */

// 渲染背景色
debugObject.clearColor = '#ffffff'

//渲染调试项
folder1
    .addColor(debugObject, 'clearColor')
    .onChange(() => {
        renderer.setClearColor(debugObject.clearColor)
    })

//渲染设置
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true,

})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.outputEncoding = THREE.sRGBEncoding
renderer.setClearColor(debugObject.clearColor)




/**
 * Loaders 设置外部文件导入器
 */
// Texture loader
const textureLoader = new THREE.TextureLoader()
const bakedTexture = textureLoader.load('baked.jpg')
bakedTexture.flipY = false
bakedTexture.encoding = THREE.sRGBEncoding


// Draco loader
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

/**
 * Materials
 */
// Baked material
const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture })


//3d场景导入
const scaleNum = 0.05

gltfLoader.load(
    'Tree Hollow.glb',
    (gltf) => {
        gltf.scene.scale.set(scaleNum, scaleNum, scaleNum)
        gltf.scene.traverse((child) => {
            child.material = bakedMaterial
        })
        scene.add(gltf.scene)

        const hollowLightMesh = gltf.scene.children.find((child) => child.name === 'HollowLight')
        const LakeMesh = gltf.scene.children.find((child) => child.name === 'lake')
        console.log(hollowLightMesh.position)

        LakeMesh.material = waterMaterial
        hollowLightMesh.material = hollowLightMaterial
    }
)


/**
 * tubes彩条
 */

function getCurve(start) {

    let scale = 0.3

    let points = []

    points.push(start)
    let currentPoint = start.clone()


    for (let i = 0; i < 600; i++) {
        let v = computeCurl(currentPoint.x / scale, currentPoint.y / scale, currentPoint.z / scale)

        let h = new THREE.Vector3((Math.random() - 0.5) * 10 + 4, (Math.random() - 0.5) * 50, (Math.random() - 0.5) * 50)
        v.add(h)

        currentPoint.addScaledVector(v, 0.001)
            // console.log(currentPoint)
        points.push(currentPoint.clone())

    }
    return points
}

import tubesVertexShader from './shaders/tubes/vertex.glsl'
import tubesFragmentShader from './shaders/tubes/fragment.glsl'

const tubesMaterial = new THREE.ShaderMaterial({
    depthWrite: false,
    blending: THREE.AdditiveBlending,
    transparent: true,
    uniforms: {
        uTime: { value: 0 },
    },
    vertexShader: tubesVertexShader,
    fragmentShader: tubesFragmentShader
})


for (let i = 0; i < 40; i++) {
    let path = new THREE.CatmullRomCurve3(
        getCurve(new THREE.Vector3(-2.0 + (Math.random() - 0.5) * 0.05, 0.307 + (Math.random() - 0.5) * 0.05, 0.35 + (Math.random() - 0.5) * 0.05))
    )
    let tubesGeometry = new THREE.TubeBufferGeometry(path, 4000, 0.00005, 8, false)



    let tubesMesh = new THREE.Mesh(tubesGeometry, tubesMaterial)
    scene.add(tubesMesh)
}


/**
 * 树洞
 */

//树洞颜色
debugObject.hollowColorStart = '#ffed94'
debugObject.hollowColorEnd = '#ffffff'

//树洞调试项
folder3
    .addColor(debugObject, 'hollowColorStart')
    .onChange(() => {
        hollowLightMaterial.uniforms.uColorStart.value.set(debugObject.hollowColorStart)
    })
folder3
    .addColor(debugObject, 'hollowColorEnd')
    .onChange(() => {
        hollowLightMaterial.uniforms.uColorEnd.value.set(debugObject.hollowColorEnd)
    })


//树洞材质

import hollowVertexShader from './shaders/hollow/vertex.glsl'
import hollowFragmentShader from './shaders/hollow/fragment.glsl'

const hollowLightMaterial = new THREE.ShaderMaterial({
    uniforms: {
        uTime: { value: 0 },
        uColorStart: { value: new THREE.Color(debugObject.hollowColorStart) },
        uColorEnd: { value: new THREE.Color(debugObject.hollowColorEnd) }
    },
    vertexShader: hollowVertexShader,
    fragmentShader: hollowFragmentShader
})




/**
 * 水面
 */

// 水面颜色
debugObject.depthColor = '#525f66'
debugObject.surfaceColor = '#1f282e'

//水面shader文件
import waterVertexShader from './shaders/water/vertex.glsl'
import waterFragmentShader from './shaders/water/fragment.glsl'

// 水面材质
const waterMaterial = new THREE.ShaderMaterial({
    vertexShader: waterVertexShader,
    fragmentShader: waterFragmentShader,
    uniforms: {
        uTime: {  value: 0 },

        uBigWavesElevation: { value: 0.02 },
        uBigWavesFrequency: { value: new THREE.Vector2(0.3, 0.2) },
        uBigWavesSpeed: { value: 0.12 },

        uSmallWavesElevation: { value: 0.04 },
        uSmallWavesFrequency: { value: 5 },
        uSmallWavesSpeed: { value: 0.2 },
        uSmallIterations: { value: 10 },

        uDepthColor: {  value: new THREE.Color(debugObject.depthColor) },
        uSurfaceColor: {  value: new THREE.Color(debugObject.surfaceColor) },
        uColorOffset: { value: 0.017 },
        uColorMultiplier: { value: 43 }
    }
})

//水面调试项
folder2.addColor(debugObject, 'depthColor').onChange(() => { waterMaterial.uniforms.uDepthColor.value.set(debugObject.depthColor) })
folder2.addColor(debugObject, 'surfaceColor').onChange(() => { waterMaterial.uniforms.uSurfaceColor.value.set(debugObject.surfaceColor) })
folder2.add(waterMaterial.uniforms.uBigWavesElevation, 'value').min(0).max(2).step(0.001).name('uBigWavesElevation')
folder2.add(waterMaterial.uniforms.uBigWavesFrequency.value, 'x').min(0).max(2).step(0.1).name('uBigWavesFrequencyX')
folder2.add(waterMaterial.uniforms.uBigWavesFrequency.value, 'y').min(0).max(2).step(0.1).name('uBigWavesFrequencyY')
folder2.add(waterMaterial.uniforms.uBigWavesSpeed, 'value').min(0).max(4).step(0.001).name('uBigWavesSpeed')
folder2.add(waterMaterial.uniforms.uSmallWavesElevation, 'value').min(0).max(2).step(0.001).name('uSmallWavesElevation')
folder2.add(waterMaterial.uniforms.uSmallWavesFrequency, 'value').min(0).max(100).step(0.01).name('uSmallWavesFrequency')
folder2.add(waterMaterial.uniforms.uSmallWavesSpeed, 'value').min(0).max(4).step(0.001).name('uSmallWavesSpeed')
folder2.add(waterMaterial.uniforms.uSmallIterations, 'value').min(0).max(10).step(1).name('uSmallIterations')
folder2.add(waterMaterial.uniforms.uColorOffset, 'value').min(0).max(1).step(0.001).name('uColorOffset')
folder2.add(waterMaterial.uniforms.uColorMultiplier, 'value').min(0).max(100).step(0.1).name('uColorMultiplier')






/**
 * 萤火虫
 */

// Geometry萤火虫几何体
const firefliesGeometry = new THREE.BufferGeometry()
const firefliesCount = 1200
const positionArray = new Float32Array(firefliesCount * 3)
const scaleArray = new Float32Array(firefliesCount)

for (let i = 0; i < firefliesCount; i++) {
    positionArray[i * 3 + 0] = (Math.random() - 0.5) * 4 - 1.3
    positionArray[i * 3 + 1] = Math.random() * 1.5
    positionArray[i * 3 + 2] = (Math.random() - 0.5) * 4
    scaleArray[i] = Math.random()
}

firefliesGeometry.setAttribute('position', new THREE.BufferAttribute(positionArray, 3))
firefliesGeometry.setAttribute('aScale', new THREE.BufferAttribute(scaleArray, 1))

//萤火虫shader文件
import firefliesVertexShader from './shaders/fireflies/vertex.glsl'
import firefliesFragmentShader from './shaders/fireflies/fragment.glsl'


// Material萤火虫材质
const firefliesMaterial = new THREE.ShaderMaterial({
    depthWrite: false,
    blending: THREE.AdditiveBlending,
    transparent: true,
    uniforms: {
        uTime: { value: 0 },
        uPixelRatio: { value: Math.min(window.devicePixelRatio, 2) },
        uSize: { value: 12 }
    },
    vertexShader: firefliesVertexShader,
    fragmentShader: firefliesFragmentShader
})

// Points萤火虫生成
const fireflies = new THREE.Points(firefliesGeometry, firefliesMaterial)
scene.add(fireflies)

//萤火虫调试项
folder4.add(firefliesMaterial.uniforms.uSize, 'value').min(0).max(500).step(1).name('firefliesSize')


/**
 * Scroll
 */
let scrollY = window.scrollY
window.addEventListener('scroll', () => {
    scrollY = window.scrollY
})

//音乐
let bgm = document.getElementById("bgm")
bgm.volume = 0.1


let bird = document.getElementById("bird")
bird.volume = 0.0


let ocean = document.getElementById("ocean")
ocean.volume = 0.2




var oPaly = document.getElementById("div")

var Play = false;
oPaly.onclick = function() {
    if (Play) {
        bgm.pause();
        bird.pause();
        ocean.pause();
        Play = false;
        oPaly.className = "div";
        oPaly.title = "播放";

    } else {
        bgm.play();
        bird.play();
        ocean.play();
        Play = true;
        oPaly.className = "div2";
        oPaly.title = "暂停";
        /* 当前时长 */

    }
}

/**
 * Cursor
 */
const cursor = {}
cursor.x = 0
cursor.y = 0

window.addEventListener('mousemove', (event) => {
    cursor.x = event.clientX / sizes.width - 0.5
    cursor.y = event.clientY / sizes.height - 0.5

})

/**
 * Animate动画
 */
const clock = new THREE.Clock()
var t = 0



const xMove = xStart - xEnd
const yMove = yStart - yEnd

const tick = () => {
    const elapsedTime = clock.getElapsedTime()

    // Update materials
    firefliesMaterial.uniforms.uTime.value = elapsedTime
    hollowLightMaterial.uniforms.uTime.value = elapsedTime

    waterMaterial.uniforms.uTime.value = elapsedTime
    tubesMaterial.uniforms.uTime.value = elapsedTime
        // Render
    renderer.render(scene, camera)

    camera.position.y -= (camera.position.y - (yStart - (scrollY / (sizes.height * 2)) * yMove)) * 0.1

    if (camera.position.y <= yMove / 20) {
        camera.position.x -= (camera.position.x - (xStart - (1 - (camera.position.y - yEnd) / (yMove / 20 - yEnd)) * xMove)) * 0.01
    }

    if (camera.position.y > yMove / 20) { camera.position.x = xStart }

    //改变音量
    bgm.volume = 0.1 - (scrollY / (sizes.height * 2)) * 0.1
    ocean.volume = 0.2 + (scrollY / (sizes.height * 2)) * 0.5
    bird.volume = (Math.pow((scrollY / (sizes.height * 2)), 5)) * 0.3

    const parallaxX = cursor.x
    const parallaxY = -cursor.y
    cameraGroup.position.z += (parallaxX - cameraGroup.position.z) * 0.1
    cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 0.1



    camera.lookAt(-2, 0.33, 0.35)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()